import scrollToTop from "../../helpers/scroll.to.top";
import { useEffect } from "react";
import SentHeader from "./components/sent.header";
import SentBody from "./components/sent.body";

export default function SentHistory() {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <section className="sent-history-page page-padding">
      <SentHeader />
      <SentBody />
    </section>
  );
}
